import styled from "styled-components";

export const RecoverButtonStyled = styled.button`
	color: var(--dz-comp-button-outline-text-color);
	border-radius: 1rem;
	padding: 0.5rem 1rem;
	background-color: var(--dz-comp-button-outline-background-color);
	font-size: 0.9rem;
	box-shadow: var(--dz-comp-auth-panel-box-shadow);
	border: 1px solid var(--dz-comp-button-outline-border-color);
	width: fit-content;

	&:hover,
	&:focus {
		background-color: var(--dz-comp-button-outline-background-color-hover);
		text-decoration: underline;
	}

	&:active {
		background-color: var(--dz-comp-button-outline-background-color-active);
		text-decoration: underline;
	}

	white-space: nowrap;
`;
